import React from 'react'
import { IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText, SvgIcon } from '@mui/material'
import { ReactComponent as PdfIcon } from 'assets/PdfIcon.svg'
import { MoreVert } from '@mui/icons-material'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import { formatStatementPeriod } from './settings'

const StatementListItem = ({ statement, onClick = noop, onClickActionMenu = noop }) => {
  const formattedPeriod = formatStatementPeriod(statement)
  return (
    <ListItem
      divider
      sx={{
        px: 2,
      }}
      dense
      disableGutters
      disablePadding
    >
      <ListItemButton onClick={onClick}>
        <ListItemIcon sx={{ minWidth: 0, pr: 2 }}>
          <SvgIcon>
            <PdfIcon />
          </SvgIcon>
        </ListItemIcon>
        <ListItemText
          primary={formattedPeriod}
          slotProps={{
            primary: {
              variant: 'h6',
              fontWeight: 500,
            },
          }}
        />
      </ListItemButton>
      <IconButton onClick={onClickActionMenu}>
        <MoreVert />
      </IconButton>
    </ListItem>
  )
}

StatementListItem.propTypes = {
  statement: PropTypes.object,
  onClick: PropTypes.func,
  onClickActionMenu: PropTypes.func,
}

export default StatementListItem
